import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export function trackUserActivity(activityData, config = {}) {
  return httpUtils.post(`${env.API_VERSION}/user-activity`, activityData, config);
}
